export default function initCart() {
    function triggerCartFormSubmit() {
        var form = document.querySelector('.cart-form-wrapper form');
        if (form) {
            form.classList.add('loading');
            form.submit();
        }
    }

    // autosubmit cartform on cartpage
    document.body.addEventListener('change', function(event) {
        if (event.target.matches('.cart-form-wrapper form input, .cart-form-wrapper form select')) {
            console.log('point 2')
            triggerCartFormSubmit();
        }
    });

    // Code for spinner value inc/dec.
    document.body.addEventListener('click', function(event) {
        if (event.target.matches('.quantity-field-holder .quantity-up')) {
            var spinner = getSpinner(event);
            var value = parseInt(spinner.value, 10);
            var max = spinner.getAttribute('max');

            if (max !== null) {
                max = parseInt(max, 10);
                if (value < max) {
                    spinner.value = value + 1;
                }
            } else {
                spinner.value = value + 1;
            }

            triggerCartFormSubmit();
        }

        if (event.target.matches('.quantity-field-holder .quantity-down')) {
            var spinner = getSpinner(event);
            var value = parseInt(spinner.value, 10);
            if (value > 0) {
                spinner.value = value - 1;
            }

            triggerCartFormSubmit();
        }
    });

    function getSpinner(event) {
        return event.target.parentElement.parentElement.previousElementSibling;
    }

    let internationalPhoneNumberField = document.getElementById('PaymentForm_OrderForm_Nobrainer-SilvershopBase-Checkout-CustomCustomerDetailsComponent_Phone')
    if (internationalPhoneNumberField){
        internationalPhoneNumberField.setAttribute('placeholder','+45 75 44 61 61')
    }
}
